import { render, staticRenderFns } from "./claapr-player.vue?vue&type=template&id=f18262ae"
import script from "./claapr-player.vue?vue&type=script&lang=ts"
export * from "./claapr-player.vue?vue&type=script&lang=ts"
import style0 from "./claapr-player.vue?vue&type=style&index=0&id=f18262ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports